/* NVZN3D TRUEVIEW AR JAVASCRIPT */

(function () {

  const nvznAppDataElement = document.getElementById('nvzn3d-trueview-data');
  if (!nvznAppDataElement) return console.error('[NVZN] nvzn3d-trueview-data not found');
  const nvznAppData = JSON.parse(nvznAppDataElement.textContent);
  log('nvzn3d-trueview-data:', nvznAppData);

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Only show the AR button if the product has an AR image
    if (!nvznAppData.product.arImage) return log('No AR image set, AR button hidden');
    document.querySelectorAll('.nvzn3d-arbutton-container').forEach((container) => {
      container.classList.add('show');
    });

    document.querySelectorAll('.nvzn3d-arbutton').forEach((button) => {
      button.addEventListener('click', function () {
        const arSize = getSelectedSize();
        if (!arSize) return console.error('[NVZN] Unable to determine AR size');
        log('Selected AR Size:', arSize);

        const dimensions = extractDimensions(arSize);
        if (!dimensions) return console.error('[NVZN] Unable to extract dimensions from arSize:', arSize);
        log('Extracted Dimensions:', dimensions);

        Nvzn3D.displayFloorPreview({
          clientId: nvznAppData.app.clientID,
          width: dimensions.width,
          length: dimensions.length,
          units: dimensions.units,
          imageUrl: nvznAppData.product.arImage,
          language: nvznAppData.app.locale || 'en',
        });

      });
    });
  }

  // Basic product (no variants): size comes from the product metafield
  // Multi variant product: size comes from the selected variant's option 1 label
  function getSelectedSize() {
    const variants = nvznAppData.product.variants;
    if (!variants) return nvznAppData.product.arSize || null;

    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant') || nvznAppData.product.selectedOrFirstAvailableVariantID.toString();
    if (!variantId) return console.error('[NVZN] Unable to determine variant ID');
    const variant = variants.find((v) => v.id.toString() === variantId);
    if (!variant) return console.error(`[NVZN] Variant with ID ${variantId} not found`);
    return variant.arSize || null;
  }

  // Parses a size split with a "/" or "x" (width/length), e.g. "200cm/300cm" or "200x300"
  // Units default to cm when not specified
  function extractDimensions(arSize) {
    if (!arSize) return null;
    const parts = arSize.toString().split(/[\/x×]/i);
    if (parts.length !== 2) return null;

    const [width, length] = parts.map((part) => {
      const match = part.trim().match(/^(\d+(?:\.\d+)?)\s*([a-z]*)$/i);
      if (!match) return null;
      return { value: parseFloat(match[1]), units: match[2].toLowerCase() };
    });
    if (!width || !length || width.value <= 0 || length.value <= 0) return null;

    return {
      width: width.value,
      length: length.value,
      units: width.units || length.units || 'cm'
    };
  }

  function log(...args) {
    if (nvznAppData.app && nvznAppData.app.logging) {
      console.log('[NVZN]', ...args);
    }
  }

  init();
})();
